import { SIGN_IN_PATH, useAuth } from "@/contexts/AuthContext";
import { useGuardedSignOut } from "@/components/LogoutSaveCheck";

/**
 * s226 (Reade: "1/ agree") — SIGN OUT in the home header, planner and executor alike (Home.dc.html: "Sign out"
 * beside the settings gear, drawn as the plan actions beside it — 12px side padding, 44px tall, 8px corners,
 * 14.5px). The board's cream home header and its gear are not built yet, so this sits at the right of today's
 * dark `nav-header`, whose own rule colours every header button white; the board's sage-600 applies once the
 * home header is rebuilt on the board's cream.
 *
 * It signs out through the app's ONE logout (AuthContext, POST /api/auth/logout) and lands on the sign-in page.
 * The "Log out" item in the account menu is unchanged and still lands on the public page (s90).
 * s227 (LOGOUT-SAVE-CHECK-1): it asks first when the Secure File has unsaved changes (`useGuardedSignOut`).
 */
export function SignOutButton() {
  const { logoutTo } = useAuth();
  const guardedSignOut = useGuardedSignOut();
  return (
    <button
      type="button"
      onClick={() => guardedSignOut(() => logoutTo(SIGN_IN_PATH))}
      className="flex min-h-[44px] items-center whitespace-nowrap rounded-[8px] px-3 text-[14.5px] hover:underline"
      data-testid="button-sign-out"
    >
      Sign out
    </button>
  );
}
